import LoadingButton from '@/shared/components/LoadingButton';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';


const nomenclaturesList = [
    { code: '!BANKS', name: 'Банки' },
    { code: '!BRANCH', name: 'Поделения' },
    { code: '!CATPERS', name: 'Категории персонал' },
    { code: '!CATWORK', name: 'Категории труд' },
    { code: '!CITY', name: 'Населени места' },
    { code: '!COMMUNITY', name: 'Месторабота - община' },
    { code: 'CONTRIBUTION', name: 'Ниво на приноса' },
    { code: '!COUNTRIES', name: 'Страни' },
    { code: '!CURRENCY', name: 'Вид валута' },
    { code: 'DOODOCS', name: 'Основни документи за ДОО' },
    { code: '!EDUCATION', name: 'Степен на образование' },
    { code: '!FAMILY', name: 'Семейно положение' },
    { code: 'FEES_N', name: 'Хонорари - начислени суми по сметка' },
    { code: 'FEES_U', name: 'Хонорари - удържани суми по сметка' },
    { code: 'GRADE', name: 'Йерархично ниво' },
    { code: 'GROUNDS_CHANGE_EMPLOYER', name: 'Основания за промяна на работодател' },
    { code: 'IBAN', name: 'IBAN ДКУ' },
    { code: 'IDNPERSONS', name: 'Персонал ЕГН' },
    { code: 'INSURANCES', name: 'Осигуровки - фондове' },
    { code: 'KINDINSURANCES', name: 'Осигуровки - вид осигуряване' },
    { code: 'KREDITORI', name: 'Кредитори' },
    { code: '!LABCONTRACT', name: 'Основания за създаване на документ за трудово правоотношение' },
    { code: '!LANGUAGES', name: 'Езици - Local settings' },
    { code: '!LEAVEREAS', name: 'Основания за прекратяване на трудово правоотношение' },
    { code: 'LEVELLANG', name: 'Ниво на владеене на език' },
    { code: 'LONGABSENCES', name: 'Дългосрочни отсъствия' },
    { code: 'NEW', name: 'NEW' },
    { code: '!NKID', name: 'Икономически дейности' },
    { code: '!NKP', name: 'Национален класификатор на професиите' },
    { code: '!NKPD', name: 'Национален класификатор на професиите и длъжностите' },
    { code: 'OFFICE', name: 'Разходни центрове' },
    { code: 'PATIENTSCARDS_REASONS', name: 'Причини за издаване на болничен лист' },
    { code: '!PERSONNEL', name: 'Персонал Служебен номер' },
    { code: '!PROFESSIONS', name: 'Професии' },
    { code: 'PROVINCES', name: 'Области' },
    { code: 'RAZHODUSLUGI', name: 'Разход външни услуги' },
    { code: 'REASONCC', name: 'Основания за сключване на граждански договори' },
    { code: 'SOCRAZH', name: 'Видове разходи за социални надбавки и помощи' },
    { code: 'SPOKEN_LANGUAGES', name: 'Езици - говорими' },
    { code: '!STRUCTGROUPS', name: 'Структурни групи' },
    { code: '!TYPEABSENCE', name: 'Видове отсъствия' },
    { code: '!TYPEN', name: 'Видове начисления' },
    { code: '!TYPEU', name: 'Видове удръжки' },
    { code: '!UNIT_SUBORDINATION', name: 'Подчиненост на организац. единица' },
    { code: 'VIDDOG', name: 'Възнаграждения по договори' },
    { code: 'VIDPRIHOD', name: 'Видове приходи' }
];

const Nomenclatures = ({ onClose, onSave, groupData }) => {
    const { t } = useTranslation();
    const [selectedNomenclatures, setSelectedNomenclatures] = useState({});
    const modalRef = useRef();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    // Initialize all nomenclatures as false
    useEffect(() => {
        const initialState = nomenclaturesList.reduce((acc, item) => {
            acc[item.code] = false;
            return acc;
        }, {});
        setSelectedNomenclatures(initialState);
    }, []);

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectedNomenclatures(prev => {
            const newState = {};
            Object.keys(prev).forEach(key => {
                newState[key] = isChecked;
            });
            return newState;
        });
    };

    const handleCheckboxChange = (code) => {
        setSelectedNomenclatures(prev => ({
            ...prev,
            [code]: !prev[code]
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        onSave(selectedNomenclatures);
        setLoading(false);
    };

    const isAllSelected = Object.values(selectedNomenclatures).every(value => value === true);

    return (
        <div className='modal show' tabIndex="-1">
            <div className="form-menus">
                <form className="form" ref={modalRef} onSubmit={handleSubmit}>
                    <div className="form-header">
                        <h2 className='title'>{t('nav.userGroups.notifications.nomenclatures')}</h2>
                    </div>

                    <div className="form-menus-input-wrapper">
                        <div className='form-input-fields'>
                            <div className="input-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    checked={isAllSelected}
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">{t('nav.userGroups.notifications.allNomenclatures')}</label>
                            </div>

                            {nomenclaturesList.map((item) => (
                                <div key={item.code} className="input-checkbox-wrapper">
                                    <input
                                        type="checkbox"
                                        id={item.code}
                                        checked={selectedNomenclatures[item.code] || false}
                                        onChange={() => handleCheckboxChange(item.code)}
                                    />
                                    <label htmlFor={item.code}>{`${item.code} - ${item.name}`}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <LoadingButton type="submit" className="btn btn-primary " loading={loading} disabled={loading}>
                            {t('common.save')}
                        </LoadingButton>
                        <button
                            type="button"
                            className="form-btn btn-red"
                            onClick={onClose}
                            style={{ marginRight: '10px' }}
                        >
                            {t('common.cancel')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Nomenclatures; 